import React, { FC } from "react";

const NewBadge: FC<{ size?: "small" | "large" }> = ({ size }) => {
  switch (size) {
    case "small":
      return (
        <span className="tw-ml-2 tw-inline-flex tw-align-middle tw-text-white tw-items-center tw-px-1.5 tw-py-0.5 tw-rounded-md tw-text-[12px] tw-font-medium tw-bg-tr">
          New
        </span>
      );
    default:
      return (
        <span className="tw-inline-block tw-align-middle tw-ml-3 tw-items-center tw-px-2.5 tw-py-0.5 tw-rounded-md tw-text-base tw-font-medium tw-bg-tr tw-text-white">
          New
        </span>
      );
  }
};

export default NewBadge;
